import React, { useEffect, useMemo, useState } from "react";
import { api, fmt2 } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Link } from "react-router-dom";

export default function VendorBookings() {
  const [bookings, setBookings] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    (async () => { try { const r = await api.get("/vendor/bookings"); setBookings(r.data); } catch (e) { /* ignore */ } })();
  }, []);

  const filtered = useMemo(() => {
    if (!q) return bookings;
    const s = q.toLowerCase();
    return bookings.filter((b) => (b.title || "").toLowerCase().includes(s) || (b.contact_email || "").toLowerCase().includes(s) || (b.contact_name || "").toLowerCase().includes(s));
  }, [bookings, q]);

  const total = filtered.reduce((s, b) => s + (b.line_final || 0), 0);

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 py-10" data-testid="vendor-bookings-page">
      <div className="flex items-end justify-between gap-3 flex-wrap">
        <div>
          <h1 className="font-display text-3xl font-semibold tracking-tight">Bookings</h1>
          <p className="text-muted-foreground">Every booking includes the 10% marketplace fee in the amount below.</p>
        </div>
        <Input placeholder="Search by trip, guest or email" value={q} onChange={(e) => setQ(e.target.value)} className="max-w-xs" data-testid="vendor-bookings-search" />
      </div>

      <div className="mt-6 rounded-2xl bg-card border border-border overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-muted-foreground text-left"><tr className="border-b border-border"><th className="p-3">Trip</th><th>Date</th><th>Guests</th><th>Guest</th><th>Status</th><th className="text-right pr-3">Amount</th></tr></thead>
          <tbody>
            {filtered.map((b) => (
              <tr key={b.booking_id} className="border-b border-border last:border-0" data-testid="vendor-booking-row">
                <td className="p-3"><Link to={`/listings/${b.listing_id}`} className="font-medium">{b.title}</Link><div className="text-xs text-muted-foreground">{b.booking_id}</div></td>
                <td>{b.date}</td>
                <td>{b.guests}</td>
                <td><div className="text-sm">{b.contact_name}</div><div className="text-xs text-muted-foreground">{b.contact_email}</div></td>
                <td><span className="text-xs rounded-full px-2 py-0.5 bg-emerald-50 text-emerald-800 capitalize">{b.status}</span></td>
                <td className="text-right pr-3 font-medium">{fmt2(b.line_final)}</td>
              </tr>
            ))}
            {filtered.length === 0 && <tr><td colSpan={6} className="p-8 text-center text-muted-foreground">No bookings found.</td></tr>}
          </tbody>
          {filtered.length > 0 && (
            <tfoot><tr className="border-t border-border"><td colSpan={5} className="p-3 text-right text-muted-foreground">Total (incl. fee)</td><td className="p-3 text-right font-semibold">{fmt2(total)}</td></tr></tfoot>
          )}
        </table>
      </div>
    </div>
  );
}
